import React from 'react';

export const ShieldOffIcon: React.FC = () => (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M32.8167 23.3333C33.1518 22.2536 33.3259 21.1304 33.3333 20V8.33331L20 3.33331L14.7333 5.29998'
            stroke='currentColor'
            strokeWidth='3.66667'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M7.88334 7.88336L6.66667 8.33336V20C6.66667 30 20 36.6667 20 36.6667C23.5284 34.8049 26.6995 32.3335 29.3667 29.3667'
            stroke='currentColor'
            strokeWidth='3.66667'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M1.66667 1.66669L38.3333 38.3334'
            stroke='currentColor'
            strokeWidth='3.66667'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);
